'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   * @Author: Paco
                                                                                                                                                                                                                                                                   * @Date: 2018-11-23 17:15:54
                                                                                                                                                                                                                                                                   * @LastEditTIme: Paco
                                                                                                                                                                                                                                                                   * @Description:
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _queryString = require('@wtdc/query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _RouteControl = require('./RouteControl');

var _RouteControl2 = _interopRequireDefault(_RouteControl);

var _configuration = require('./configuration');

var _configuration2 = _interopRequireDefault(_configuration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 获取 正常的module内容
 *
 * @param module
 * @returns {*}
 */
function getModule(module) {
  if (module) {
    return module.__esModule ? module.default : module;
  } else {
    return null;
  }
}

/**
 * 默认的Home组件
 *
 * @param children
 * @returns {*|null}
 */
function getDefaultComponent() {
  return function (_ref) {
    var children = _ref.children;

    return children || null;
  };
}

/**
 * 将search解析成query，赋值于query上，保持query指向同一份内存，避免触发不必要的渲染
 * @param query：search解析结果缓存
 * @param search：本次render的查询参数
 * @param prevSearch：上一次render的查询参数
 */
function parseQuery(query, search, prevSearch) {
  // search没有发生变化，直接返回上一次的解析结果
  if (search === prevSearch) {
    return query;
  }

  // 剔除query中原有的参数
  Object.keys(query).forEach(function (key) {
    if (query.hasOwnProperty(key)) {
      delete query[key];
    }
  });

  // 将新的search值进行解析并赋值在query上
  Object.assign(query, _queryString2.default.parse(search));
  return query;
}

exports.default = function (_ref2) {
  var _ref2$getComponent = _ref2.getComponent,
      getComponent = _ref2$getComponent === undefined ? getDefaultComponent : _ref2$getComponent,
      _ref2$childRoutes = _ref2.childRoutes,
      childRoutes = _ref2$childRoutes === undefined ? [] : _ref2$childRoutes,
      _ref2$getChildRoutes = _ref2.getChildRoutes,
      getChildRoutes = _ref2$getChildRoutes === undefined ? function () {
    return [];
  } : _ref2$getChildRoutes,
      onEnter = _ref2.onEnter;

  var Component = getModule(getComponent());
  var dynamicRoutes = getChildRoutes();
  var children = [].concat(childRoutes);
  var ErrorBoundary = _configuration2.default.ErrorBoundary,
      combinePath = _configuration2.default.combinePath;


  if (dynamicRoutes instanceof Array && dynamicRoutes.length) {
    children = children.concat(dynamicRoutes);
  }

  var query = {}; // search解析结果缓存
  var prevSearch = ''; // 上一次render的查询参数

  return function RouterBase(props) {
    var match = props.match,
        location = props.location;

    var renderComponent = _react2.default.createElement(
      Component,
      _extends({}, props, {
        query: parseQuery(query, location.search, prevSearch)
      }),
      !match.isExact && children.map(function (childRoute, index) {
        return _react2.default.createElement(_reactRouterDom.Route, {
          path: combinePath(match.path, childRoute.path),
          component: getModule(childRoute.component),
          key: index
        });
      })
    );

    // update prev search
    prevSearch = location.search;

    var renderRouter = typeof onEnter === 'function' ? _react2.default.createElement(
      _RouteControl2.default,
      _extends({}, props, { onEnter: onEnter }),
      renderComponent
    ) : renderComponent;

    return ErrorBoundary ? _react2.default.createElement(
      ErrorBoundary,
      null,
      renderRouter
    ) : renderRouter;
  };
};

exports.setConfig = _configuration.setConfig;